import {
  GenerateAuditTrailEsignatureSignatureDocument,
  GenerateAuditTrailEsignatureSignatureMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useGenerateAuditTrailEsignatureSignature = () => {
  const [generateAuditTrailEsignatureSignature, { loading }] = useMutation(
    GenerateAuditTrailEsignatureSignatureDocument,
    {
      extractorFn: (data) => data.esignatureMutations.generateAuditTrailEsignatureSignature,
    }
  )

  return {
    loading,
    generateAuditTrail(variables: GenerateAuditTrailEsignatureSignatureMutationVariables) {
      return generateAuditTrailEsignatureSignature({
        variables,
      })
    },
  }
}
